function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-7.303 -3.342)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M40.94 3.846h-13.4v14.005c0 2.062 3.015 3.736 6.734 3.736 3.72 0 6.64-1.674 6.64-3.736l.025-14.005z",
  fill: "#fff",
  stroke: "#20201e",
  strokeWidth: 1.008
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#20201e",
  strokeWidth: 1.008,
  d: "M27.539 3.846H40.94v12.008H27.539z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#20201e",
  strokeWidth: 1.008,
  d: "M27.539 3.846l13.402 12.008M40.941 3.846L27.539 15.854"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.545 50.873c-5.214-2.573-10.88-3.926-17.088-3.926-6.207 0-12.143 1.443-17.358 4.015 5.215 2.573 11.05 4.054 17.256 4.054 6.21.009 11.979-1.564 17.19-4.137z",
  fill: "#fff",
  stroke: "#20201e",
  strokeWidth: 1.008,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.15 42.05c.3-.262.597-.53.888-.813 6.301-6.131 7.745-14.869 3.224-19.516-4.523-4.648-13.296-3.444-19.598 2.687-1.882 1.831-3.327 3.895-4.313 6.013-.985-2.118-2.43-4.182-4.312-6.013-6.301-6.13-15.077-7.335-19.598-2.687-4.522 4.647-3.079 13.386 3.224 19.516.291.283.59.553.89.814 5.442-2.043 12.32-3.264 19.8-3.264 7.476 0 14.352 1.224 19.787 3.263z",
  fill: "#fff",
  stroke: "#20201e",
  strokeWidth: 1.008,
  strokeLinejoin: "bevel"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.356 30.429c.986-2.118 2.43-4.182 4.313-6.013a20.823 20.823 0 014.95-3.588 34.234 34.234 0 00-9.258-1.252c-3.266 0-6.39.445-9.263 1.254a20.868 20.868 0 014.946 3.586c1.881 1.832 3.321 3.896 4.312 6.01z",
  fill: "#fff",
  stroke: "#20201e",
  strokeWidth: 1.008
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.076 42.05l-.003-.005c-5.439-2.041-12.312-3.26-19.787-3.26-7.482 0-14.36 1.221-19.8 3.264 0 0 2.61 2.044 2.987 3.554.378 1.509.54 3.673-.367 5.355 5.214-2.572 11.15-4.015 17.358-4.015 6.088 0 11.95 1.445 17.088 3.926-.829-1.661-.83-3.799-.463-5.266.374-1.498 2.988-3.546 2.988-3.546z",
  fill: "#fff",
  stroke: "#20201e",
  strokeWidth: 1.008,
  strokeLinejoin: "bevel"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.1 50.964c5.215-2.572 11.151-4.015 17.359-4.015 6.088 0 11.949 1.445 17.088 3.926-.353-.71-.723-2.522-.664-3.533a44.972 44.972 0 00-33.188.066c.067 1.873-.2 2.813-.591 3.546z",
  fill: "#fff",
  stroke: "#20201e",
  strokeWidth: 1.008,
  strokeLinejoin: "bevel"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.39 42.857l2.572-1.29-2.572-1.29-2.58 1.29zM24.01 44.105l2.339-1.69-2.747-.857-2.34 1.69zM44.761 44.105l-2.339-1.69 2.747-.857 2.34 1.69z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 34.356,
  cy: 19.767,
  rx: 4.744,
  ry: 3.503,
  fill: "#fff",
  stroke: "#20201e",
  strokeWidth: 1.008
}));

function SvgWhiteKing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.095 52.178"
  }, props), _ref);
}

export default SvgWhiteKing;